import { HttpContextAlpha } from '@blufin/react-core';
import type { ReactNode } from 'react';
import React, { useEffect, useRef } from 'react';
import { HttpClientPublicAlpha } from './HttpClientPublicAlpha';
import { useEnvironmentAlpha } from '../../../hooks/useEnvironment/useEnvironmentAlpha';

interface SiteHttpProviderAlphaProps {
  children?: ReactNode;
}

/**
 * HTTP provider for Next.js sites using HttpClientPublicAlpha.
 * Provides via the existing HttpContextAlpha context so useHttpClientBeta() works unchanged.
 * Must be rendered inside NextJsEnvironmentProviderAlpha.
 * @param root0 - Component props.
 * @param root0.children - React child elements to be wrapped by the provider.
 */
export const SiteHttpProviderAlpha: React.FC<SiteHttpProviderAlphaProps> = ({ children }) => {
  const httpClientRef = useRef<HttpClientPublicAlpha | null>(null);
  const environmentClient = useEnvironmentAlpha();
  const httpClientConfig = environmentClient.apiConfig;

  if (!httpClientConfig) throw new Error('SiteHttpProviderAlpha requires apiConfig in runtime configuration');
  if (!httpClientRef.current) httpClientRef.current = new HttpClientPublicAlpha(httpClientConfig);

  useEffect(() => {
    return () => {
      if (httpClientRef.current) httpClientRef.current.terminate();
    };
  }, []);

  return <HttpContextAlpha.Provider value={httpClientRef.current}>{children}</HttpContextAlpha.Provider>;
};
